// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-card {
  display: flex;
  /* max-width: 880px; */
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  align-items: center;
  width: 880px;
}

.product-card:hover {
  /* box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05); */
}

.product-card-left {
  width: 210px;
  padding: 10px;
  /* border-right: 1px solid #e8e8e8; */
}

.product-card-left img {
  width: 190px;
  height: 200px;
}

.product-card-right {
  padding: 20px 30px 18px;
  /* border-left: 1px solid #e8e8e8; */
}

.product-card-top-meta {
  display: flex;
  font-size: 13px;
  font-family: "Roboto", sans-serif;

  color: #999;
  line-height: 15px;
}

.product-card-top-meta .seller {
  color: #3686fe;
  margin-right: 10px;
}

.product-card h3 {
  font-size: 18px;
  font-family: "Roboto", sans-serif;

  line-height: 22px;
  margin-top: 12px;
  margin-bottom: 6px;
}

.product-card .price-sec {
  display: flex;
  align-items: center;
  gap: 6px;
  font-family: "Roboto", sans-serif;

  font-size: 14px;
}

.product-card .price-sec .price {
  font-size: 18px;
  color: #d20000;
  font-weight: 500;
}

.product-card .price-sec .price-mrp {
  color: #bbb;
  font-size: 14px;
  margin-left: 6px;
  text-decoration: line-through;
}

.product-card .price-sec .discount {
  color: #d20000;
}

.product-card .description {
  color: #444;
  flex: 1 1;
  font-family: "Roboto", sans-serif;
  font-size: 14px;
  font-style: italic;
  line-height: 18px;
  margin: 2px 0;
}

.product-card .review-btns {
  display: flex;
  gap: 10px;
}

.product-card .review-btns > button {
  background-color: #f6f6f6;
  border-radius: 4px;
  color: #333;
  cursor: pointer;
  font-size: 12px;
  height: 29px;
  line-height: 16px;
  padding: 0 8px;
}

.product-card-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.product-card .main-btn {
  background-color: #ea4b4d;
  /* font-family: "Roboto", sans-serif; */
  border-radius: 4px;
  color: #fff;
  font-size: 15px;
  font-weight: 500;
  height: 40px;
  line-height: 18px;
  width: 160px;
  margin-top: 10px;
}

.product_image {
  width: 190px;
  height: 200px;
  background-size: cover;
}

@media (max-width: 550px) {
  .product-card {
    flex-direction: column;
    width: 100%;
  }
  .product_image {
    margin-top: 10px;
  }

  #all-deals {
    padding: 0px 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/productcard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,iCAAiC;;EAEjC,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iCAAiC;;EAEjC,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iCAAiC;;EAEjC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,SAAO;EACP,iCAAiC;EACjC,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,uCAAuC;EACvC,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE;IACE,sBAAsB;IACtB,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".product-card {\n  display: flex;\n  /* max-width: 880px; */\n  border: 1px solid #e8e8e8;\n  border-radius: 6px;\n  align-items: center;\n  width: 880px;\n}\n\n.product-card:hover {\n  /* box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.05); */\n}\n\n.product-card-left {\n  width: 210px;\n  padding: 10px;\n  /* border-right: 1px solid #e8e8e8; */\n}\n\n.product-card-left img {\n  width: 190px;\n  height: 200px;\n}\n\n.product-card-right {\n  padding: 20px 30px 18px;\n  /* border-left: 1px solid #e8e8e8; */\n}\n\n.product-card-top-meta {\n  display: flex;\n  font-size: 13px;\n  font-family: \"Roboto\", sans-serif;\n\n  color: #999;\n  line-height: 15px;\n}\n\n.product-card-top-meta .seller {\n  color: #3686fe;\n  margin-right: 10px;\n}\n\n.product-card h3 {\n  font-size: 18px;\n  font-family: \"Roboto\", sans-serif;\n\n  line-height: 22px;\n  margin-top: 12px;\n  margin-bottom: 6px;\n}\n\n.product-card .price-sec {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-family: \"Roboto\", sans-serif;\n\n  font-size: 14px;\n}\n\n.product-card .price-sec .price {\n  font-size: 18px;\n  color: #d20000;\n  font-weight: 500;\n}\n\n.product-card .price-sec .price-mrp {\n  color: #bbb;\n  font-size: 14px;\n  margin-left: 6px;\n  text-decoration: line-through;\n}\n\n.product-card .price-sec .discount {\n  color: #d20000;\n}\n\n.product-card .description {\n  color: #444;\n  flex: 1;\n  font-family: \"Roboto\", sans-serif;\n  font-size: 14px;\n  font-style: italic;\n  line-height: 18px;\n  margin: 2px 0;\n}\n\n.product-card .review-btns {\n  display: flex;\n  gap: 10px;\n}\n\n.product-card .review-btns > button {\n  background-color: #f6f6f6;\n  border-radius: 4px;\n  color: #333;\n  cursor: pointer;\n  font-size: 12px;\n  height: 29px;\n  line-height: 16px;\n  padding: 0 8px;\n}\n\n.product-card-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.product-card .main-btn {\n  background-color: #ea4b4d;\n  /* font-family: \"Roboto\", sans-serif; */\n  border-radius: 4px;\n  color: #fff;\n  font-size: 15px;\n  font-weight: 500;\n  height: 40px;\n  line-height: 18px;\n  width: 160px;\n  margin-top: 10px;\n}\n\n.product_image {\n  width: 190px;\n  height: 200px;\n  background-size: cover;\n}\n\n@media (max-width: 550px) {\n  .product-card {\n    flex-direction: column;\n    width: 100%;\n  }\n  .product_image {\n    margin-top: 10px;\n  }\n\n  #all-deals {\n    padding: 0px 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
